<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { Button, Col, FormGroup, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Popover, Row } from "sveltestrap";
    import type { Complainant } from "../Model/Complainant";
    import type { RegisterCitation } from "../Model/RegisterCitation";
    import type { Third } from "../Model/Third";
	import { containsService, fileServices, paramsService, procedencesService, recordsCitationService, thirdsService, usersService, writeFileService } from "../services";
    import { dateInputFormatter, dateTimeInputFormatter } from "../services/Functions";
    import AddThirdList from "./AddThirdList.svelte";
    import ParamSelect from "./ParamSelect.svelte";
    import ProcedenceSelect from "./procedenceSelect.svelte";
    import ThirdNameInput from "./ThirdNameInput.svelte";
    import ContainSelect from "./containSelect.svelte"
    import { REGISTERSCITATIONS } from "../evironment";
    import type { User } from "../Model/User";

	const dispatch = createEventDispatcher();

	$: user();

	let size = 'lg';
	let open = false;
	let changeThird = false;
	let third: Third;
	let currentUser: User;

	let date: string;
	let time: string;
	let buttonIn = true;
	let buttonOut = true;
	let deleteIn, deleteOut = false;
	let files: any[] = [];
	let pop = false;
	const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));

	export let register: RegisterCitation = null;
	export let newRegister: boolean = false;

	$: open = !!register; 

	const toggle = () => {
	  size = 'lg';
	  open = !open;
	};

	async function user() {
		currentUser = await usersService.findActualUser();
	}

	async function save(){

		const response = await saveRegister();

		if(response){
			open = false;
			dispatch("registerUpdate");
		}
	}

	async function saveRegister(){
		return await recordsCitationService.saveRegisters(register);
	}

	async function changeThirdEvent(third){
    	register.thirdId = third.id;
    	changeThird = false;
    	dispatch("changeThirdLIst", third);
  	}

	async function generateInput(type:string,visibility:boolean) {
		if (type == 'in') {
			let inReg = document.querySelector('#inReg');
			let inDate = document.querySelector('#inDate');
			
			if (visibility) {
				inReg.disabled = visibility;
				inDate.disabled = visibility;
				buttonIn = visibility;
				deleteIn = false;

				register.inRegistNumber = null;
				register.inDate = null;
			} else {
				inReg.disabled = visibility;
				inDate.disabled = visibility;
				buttonIn = visibility;
			 	deleteIn = true;

				register.inRegistNumber = parseInt(await recordsCitationService.lastInRegister(new Date().getFullYear()));
				register.inDate = new Date();
			}
		} else if (type == 'out') {
			let outReg = document.querySelector('#outReg');
			let outDate = document.querySelector('#outDate');
			
			if (visibility) {
				outReg.disabled = visibility;
				outDate.disabled = visibility;
				buttonOut = visibility;
				deleteOut = false;

				register.outRegistNumber = null;
				register.outDate = null;
			} else {
				outReg.disabled = visibility;
				outDate.disabled = visibility;
				buttonOut = visibility;
			 	deleteOut = true;

				register.outRegistNumber = parseInt(await recordsCitationService.lastOutRegister(new Date().getFullYear()));
				register.outDate = new Date();
			}
		}
	}

	async function download(fileId) {
		try {
			await writeFileService.writeCitationFile(register, fileId);
		} catch(error) {
			console.log(error);
		}
	}

	async function chooseFile() {
		try {
			files = await fileServices.findFilesByContext(REGISTERSCITATIONS);
		} catch(error) {

		}
	}
  </script>
  
	<Modal isOpen={open} {toggle} {size}>
		<ModalHeader {toggle}>Editar Registro De Citaciones</ModalHeader>
		<ModalBody>
			<Row>
				<Col xs="7">
					<FormGroup>
						<Label for="exampleEmail">Registro de entrada</Label>
						<Input
							id='inReg'
							disabled
						  	type="text"
						  	bind:value={register.inRegistNumber}
						/>
					</FormGroup>
                </Col>
                <Col xs="4">
					<FormGroup>
						<Label for="exampleEmail">Fecha de entrada</Label>
						<Input
							id='inDate'
							disabled
                            type="date"
                            value={dateInputFormatter(register.inDate)}  
                            on:change={(event)=>register.inDate = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs='1'>
						<FormGroup>
							{#if buttonIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('in',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('in',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
                <Col xs="7">
                    <FormGroup>
						<Label for="exampleEmail">Registro de Salida</Label>
						<Input
							id='outReg'
							disabled
							type="text"
							bind:value={register.outRegistNumber}
						/>
					</FormGroup>
                </Col>
                <Col xs="4">
                    <FormGroup>
						<Label for="exampleEmail">Fecha de salida</Label>
						<Input
							id='outDate'
							disabled
						    type="date"
                            value={dateInputFormatter(register.outDate)}  
                            on:change={(event)=>register.outDate = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs='1'>
						<FormGroup>
							{#if buttonOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('out',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('out',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
                <Col xs="6">
                    <FormGroup>
						<Label for="exampleEmail">Procedencia</Label>
						<ProcedenceSelect procedenceSelectId={register.origin} />
					</FormGroup>
                </Col>
                <Col xs="12">
                    <FormGroup>
						<Label for="exampleEmail">Solicita</Label>
						<Input
                            type="textarea"
                            rows={6}
						    bind:value={register.request}
						/>
					</FormGroup>
                </Col>
                <Col xs="4">
                    <FormGroup>
						<Label for="exampleEmail">Agente</Label>
                        <ParamSelect
                            bind:paramSelectId = {register.agentId}
                            paramType = 'agentList'
                            nothing = {true}
                        />
					</FormGroup>
                </Col>
                <Col xs="8">
                    <FormGroup>
						<Label for="exampleEmail">Tercero</Label>
						<div class="input-group">
							<ThirdNameInput id={register.thirdId} />
							<button
								class="btn btn-secondary"
								type="button"
								id="complainantThirId"
								name="complainantThirId"
								on:click={() => {if(changeThird){changeThird = false} else {changeThird = true}}}
							>
								<Icon name="plus" />
							</button>
						</div>

						{#if changeThird}
							<div class="m-3 p-2 border rounded third-box-modal">
								<h5>Busqueda de Terceros</h5>
          						<AddThirdList on:changeThird={(event) => changeThirdEvent(event.detail)} />
								<div class='text-end mt-2'>
									<a href="/tercero/new" class='btn btn-success text-white text-decoration-none' target='_blank'>Crear tercero</a>
								</div>
							</div>
						{/if}
					</FormGroup>
                </Col>
                <Col xs="12">
                    <FormGroup>
						<Label for="exampleEmail">Informe</Label>
						<Input
                            type="textarea"
                            rows={6}
						    bind:value={register.report}
						/>
					</FormGroup>
                    <FormGroup>
						<Label for="exampleEmail">Contenido</Label>
                        <ContainSelect bind:containSelectId={register.content} module='Registro de Citaciones Judiciales' />
					</FormGroup>
                </Col>
                <Col xs="4">
                    <FormGroup>
						<Label for="exampleEmail">Bloqueo de salida</Label>
                        <Input 
                            type="checkbox" 
                            label="Bloqueado"  
                            bind:checked={register.outPutLock}
                        />
					</FormGroup>
                </Col>
                <Col xs="8">
                    <FormGroup>
						<Label for="exampleEmail">Número de expediente</Label>
						<Input
						  type="text"
						  bind:value={register.expedientNumber}
						/>
					</FormGroup>
                </Col>
			</Row>

	  	</ModalBody>
	  	<ModalFooter>
			<Button color='success' id="btnDismissible" on:click={() => {chooseFile(); pop == false ? pop = true : pop = false}}>Descargar documento</Button>
			{#if pop}
					<div class='pop bg-white shadow-lg rounded-3 border border-1' >
						<div class='bg-light p-2 border- border-bottom'>
							Seleccione un fichero
						</div>
						<div class='p-4 d-flex flex-column'>
							{#if files.length > 0}
								{#each files as file}
									<button class='btn btn-secondary mb-2 fs-6' on:click={async() => {download(file.id); await delay(500).then(() => pop = false) }}>{file.name}</button>
								{/each}
							{:else}
								<span>No hay ficheros para descargar</span>
							{/if}
						</div>
					</div>
				{/if}
			<Button color="primary" on:click={save}>Guardar</Button>
	  	</ModalFooter>
	</Modal>

	<style>
		.pop {
			position: absolute;
			bottom: 60px;
			right: 100px;
			width: auto;
		}
	</style>